import axios from "../../config/axiosConfig";
import {
  PURCHASE_OUTSTANDING_REPORT_REQUEST,
  PURCHASE_OUTSTANDING_REPORT_SUCCESS,
  PURCHASE_OUTSTANDING_REPORT_FAILURE,
  PURCHASE_OUTSTANDING_FILTER_REPORT_REQUEST,
  PURCHASE_OUTSTANDING_FILTER_REPORT_SUCCESS,
  PURCHASE_OUTSTANDING_FILTER_REPORT_FAILURE
} from "../types/purchase-outstanding-report-types";

export const getPurchaseOutstandingRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_OUTSTANDING_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      console.log('params', params);
      
      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/outstanding-report/getPurchaseReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.get('/outstanding-report/getPurchaseReport', {
        params: requestParams,
      }).then((response) => {
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PURCHASE_OUTSTANDING_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Purchase Outstanding Report:", error);
        dispatch({ type: PURCHASE_OUTSTANDING_REPORT_FAILURE, error: error.message });          
      });
    } catch (error) {
      console.error("Error fetching Purchase Outstanding Report:", error);
      dispatch({ type: PURCHASE_OUTSTANDING_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getPurchaseOutstandingRegisterReportFilterDetail = (isCommonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PURCHASE_OUTSTANDING_FILTER_REPORT_REQUEST });
            const { auth } = getState();
            let defaultParams = {};
            if (isCommonMaster) {
                defaultParams = {
                    // companyId: auth.company?.id,
                    customerId: auth.user?.Customer_Id,
                };
            } else {
                defaultParams = {
                    companyId: auth.company?.id,
                    customerId: auth.user?.Customer_Id,
                };
            }
            // const defaultParams = {
            //     companyId: auth.company?.id,
            //     customerId: auth.user?.Customer_Id,
            // };
            const requestParams = { ...defaultParams };
            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/outstanding-report/getPurchaseReportFilters?${queryString}`;
            console.log('<<Complete API Request URL: ', fullUrl);
            return axios.get(fullUrl).then((response) => {
                console.log('API Response Data: ', response);
                if (response.data) {
                dispatch({ type: PURCHASE_OUTSTANDING_FILTER_REPORT_SUCCESS, payload: response.data });
                }
            }).catch((error) => {
                console.error("Error fetching purchase outstanding Report Filters:", error);
                dispatch({ type: PURCHASE_OUTSTANDING_FILTER_REPORT_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error("Error fetching purchase outstanding Report Filters:", error);
            dispatch({ type: PURCHASE_OUTSTANDING_FILTER_REPORT_FAILURE, error: error.message });
        }
    };
};

export const clearPurchaseOutstandingRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: PURCHASE_OUTSTANDING_REPORT_SUCCESS, payload: {} });
  }
}
